import * as Yup from 'yup';
import { Common } from 'utils/constants';
import { IDriverDetailForm, IDriverPasswordResetForm } from 'models/driver';
import { TFunction } from 'i18next';
import { IAddNotesForm } from 'types/stateTypes';

export const DriverValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        driver_tags: Yup.array().of(
            Yup.object().shape({
                label: Yup.string().required(),
                value: Yup.string()
                    .required()
                    .matches(
                        Common.RegularExpression.AlphaNumericWithSpaceAndDashUnderScoreRegex,
                        t('driver.errors.tag.invalid_fromat'),
                    ),
            }),
        ),
        languagePreference: Yup.mixed().nullable().required('required'),
    }) as unknown as Yup.SchemaOf<IDriverDetailForm>;
};
export const DriverPasswordResetValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        password: Yup.string()
            .required('required')
            .matches(
                Common.RegularExpression.DriverPasswordRegularExpression,
                t('driver.errors.password.passwordFormat'),
            ),
    }) as Yup.SchemaOf<IDriverPasswordResetForm>;
};
export const AddNotesValidationSchema = () => {
    return Yup.object().shape({
        remark: Yup.string().trim().nullable().required('required'),
    }) as Yup.SchemaOf<IAddNotesForm>;
};
